// extracted by mini-css-extract-plugin
export var disclaimer = "styles-module--disclaimer--+YfEs";
export var feedback = "styles-module--feedback--a+4Cp";